import { buildUrl } from './utils';

const state = {};
const actions = {
  get(context, { projectId }) {
    const url = buildUrl([
      {
        projects: projectId
      },
      {
        skills: null
      }
    ]);
    return this._vm.$http.get(url).then(({ data }) => Promise.resolve(data));
  },
  create({ rootState: { token } }, { projectId, name } = {}) {
    const url = buildUrl([
      {
        projects: projectId
      },
      {
        skills: null
      }
    ]);
    return this._vm.$http
      .post(
        url,
        {
          name
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(({ data }) => Promise.resolve(data));
  },
  update({ rootState: { token } }, { projectId, skillId, name } = {}) {
    const url = buildUrl([
      {
        projects: projectId
      },
      {
        skills: skillId
      }
    ]);
    return this._vm.$http
      .put(
        url,
        {
          name
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(({ data }) => Promise.resolve(data));
  },
  share({ rootState: { token } }, { projectId, skillId, newProjectId } = {}) {
    console.log('newProjectId :>> ', newProjectId);
    const url = buildUrl([
      {
        projects: projectId
      },
      {
        skills: skillId
      },
      {
        share: ''
      }
    ]);
    return this._vm.$http
      .put(
        url,
        {
          newProjectId
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(({ data }) => Promise.resolve(data));
  },
  projects({ rootState: { token } }, { projectId, skillId } = {}) {
    const url = buildUrl([
      {
        projects: projectId
      },
      {
        skills: skillId
      },
      {
        available: ''
      }
    ]);
    return this._vm.$http
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(({ data }) => Promise.resolve(data));
  },
  remove({ rootState: { token } }, { projectId, skillId } = {}) {
    const url = buildUrl([
      {
        projects: projectId
      },
      {
        skills: skillId
      }
    ]);
    return this._vm.$http
      .delete(
        url,
        {
          name
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(({ data }) => Promise.resolve(data));
  }
};
export default {
  namespaced: true,
  state,
  actions
};
